import React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import Svg, { Circle, Defs, LinearGradient, Stop } from 'react-native-svg'

import { DS } from '../../design-system'

const CircularGradientProgress = ({
  size,
  strokeWidth,
  progress,
  colors
}: {
  size: number
  strokeWidth: number
  progress: number
  colors: string[]
}) => {
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const strokeDashoffset = circumference - (progress / 100) * circumference

  return (
    <View style={{ width: size, height: size }}>
      <Svg height={size} width={size}>
        <Circle
          stroke="#DDDAD2" // Light grey background
          fill="none"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
        />
        <Defs>
          <LinearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="0%">
            {colors.map((color: string, index: number) => (
              <Stop key={index} offset={`${(index / (colors.length - 1)) * 100}%`} stopColor={color} stopOpacity="1" />
            ))}
          </LinearGradient>
        </Defs>
        <Circle
          stroke="url(#grad)"
          fill="none"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="butt"
          rotation="-90"
          origin={`${size / 2}, ${size / 2}`}
        />
      </Svg>
      <View style={styles.center}>
        {/* Displaying progress percentage */}
        <DS.Text variant="Heading 3/Medium">{Math.round(progress)}%</DS.Text>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  center: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: 'center',
    alignItems: 'center'
  },
  progressText: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#333'
  }
})

export default CircularGradientProgress
